import BaseApi from './baseApi';
import IRolePermission from '../models/IRolePermission';
import IAuthentication from '../models/IAuthentication';
export default class RolePermissionApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Roles");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetRolePermissions(roleId: string) : Promise<IRolePermission[]> {
        const json = this.getJsonRead(roleId);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var rolePermissions: IRolePermission[] = [];
            rolePermissions = response.data as IRolePermission[];
            return rolePermissions;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveRolePermission(rolePermission: IRolePermission) : Promise<string> {
        const json = this.getJsonSave(rolePermission);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateRolePermission(rolePermission: IRolePermission) : Promise<boolean> {
        const json = this.getJsonUpdate(rolePermission);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteRolePermissionsByRoleId(roleId: string) : Promise<boolean> {
        const json = this.getJsonDelete(roleId);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDelete(idRole: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "RolesPermissions",
            "conditions": [{
                "Item1": "RolesPermissions",
                "Item2": "id",
                "Item3": "=",
                "Item4": idRole
            }]
        };
        return json;
    }

    private getJsonSave(rolePermission: IRolePermission) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idForm",
                "Item2": rolePermission.idForm
            }, {
                "Item1": "isAccesible",
                "Item2": rolePermission.isAccesible
            }, {
                "Item1": "isReadable",
                "Item2": rolePermission.isReadable
            }, {
                "Item1": "isWritable",
                "Item2": rolePermission.isWritable
            }, {
                "Item1": "isErasable",
                "Item2": rolePermission.isErasable
            }, {
                "Item1": "idRole",
                "Item2": rolePermission.idRole
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "RolesPermissions"
        };
        return json;
    }

    private getJsonUpdate(rolePermission: IRolePermission) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idForm",
                "Item2": rolePermission.idForm
            }, {
                "Item1": "isAccesible",
                "Item2": rolePermission.isAccesible
            }, {
                "Item1": "isReadable",
                "Item2": rolePermission.isReadable
            }, {
                "Item1": "isWritable",
                "Item2": rolePermission.isWritable
            }, {
                "Item1": "isErasable",
                "Item2": rolePermission.isErasable
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "RolesPermissions",
            "keyvalue": rolePermission.id
        };
        return json;
    }

    private getJsonRead(roleId: string) : any {
        const json = {
            "fields": [{
                "Item1": "RolesPermissions",
                "Item2": "id"
            }, {
                "Item1": "RolesPermissions",
                "Item2": "idForm"
            }, {
                "Item1": "Forms",
                "Item2": "formName"
            }, {
                "Item1": "RolesPermissions",
                "Item2": "isAccesible"
            }, {
                "Item1": "RolesPermissions",
                "Item2": "isReadable"
            }, {
                "Item1": "RolesPermissions",
                "Item2": "isWritable"
            }, {
                "Item1": "RolesPermissions",
                "Item2": "isErasable"
            }, {
                "Item1": "RolesPermissions",
                "Item2": "idRole"
            }],
            "tables": [{
                "Item1": "RolesPermissions"
            }, {
                "Item1": "Forms"
            }],
            "joins": [{
                "Item1": "RolesPermissions",
                "Item2": "IdForm",
                "Item3": "Forms",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "RolesPermissions",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "RolesPermissions",
                "Item2": "idRole",
                "Item3": "=",
                "Item4": roleId
            }]
        };
        return json;
    }
}
